import { HelpIcon } from './HelpIcon';

export function SelectField({ id, label, value, onChange, options = [], error, helpText, required, readOnly }) {
  const hasGroups = options.some(o => o.group);
  const grouped = hasGroups
    ? options.reduce((acc, o) => { const g = o.group || 'Other'; (acc[g] = acc[g] || []).push(o); return acc; }, {})
    : null;
  return (
    <div className="fw">
      <label className="fl" htmlFor={`field-${id}`}>
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <select id={`field-${id}`} value={value ?? ''} onChange={e => onChange(e.target.value)}
        disabled={readOnly} aria-invalid={!!error}
        className={`field-select${error ? ' field-error-border' : ''}`}>
        <option value="">— Select —</option>
        {hasGroups
          ? Object.entries(grouped).map(([g, opts]) => (
              <optgroup key={g} label={g}>{opts.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}</optgroup>
            ))
          : options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)
        }
      </select>
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
